import { computed } from 'vue'
import { useFavoritesStore } from './store/favorites'
import type { Product } from '@/types/catalog'

export function useFavoritesSummary() {
  const favoritesStore = useFavoritesStore()

  return {
    favoritesCount: computed(() => favoritesStore.favoritesCount),
  }
}

/**
 * Публичный контракт toggle-в-избранное для карточек товара вне profile-модуля
 * (catalog/ProductCard, catalog/ProductQuickView) - без доступа к списку
 * избранного, localStorage-гостевому кэшу и auth-проверкам внутри store.
 */
export function useFavoritesActions() {
  const favoritesStore = useFavoritesStore()

  return {
    isFavorite: (productId: string | number) => favoritesStore.isFavorite(productId),
    toggleFavorite: (product: Product) => favoritesStore.toggleFavorite(product),
  }
}

/**
 * Публичный контракт auth-prompt UX для favorites-флоу (используется общим
 * `AuthPromptModal` вне profile-модуля) - без доступа к остальному store.
 */
export function useFavoritesAuthPrompt() {
  const favoritesStore = useFavoritesStore()

  return {
    showAuthPrompt: computed(() => favoritesStore.showAuthPrompt),
    closeAuthPrompt: () => favoritesStore.closeAuthPrompt(),
  }
}

/**
 * Публичный контракт FavoritesView (owner module) - без импорта store.
 */
export function useFavoritesWorkspace() {
  const favoritesStore = useFavoritesStore()

  return {
    favorites: computed(() => favoritesStore.favorites),
    clearAll: () => favoritesStore.clearAll(),
    loadFavorites: () => favoritesStore.loadFavorites(),
    fetchRecommended: () => favoritesStore.fetchRecommended(),
  }
}

/** Side-effect hooks for auth session lifecycle (без reach-in в store). */
export async function mergeGuestFavoritesOnLogin(): Promise<void> {
  await useFavoritesStore().mergeGuestFavorites()
}

export function clearFavoritesOnLogout(): void {
  useFavoritesStore().favorites = []
}
